module.exports = __webpack_public_path__ + "static/media/Statua_058.2c04799f.jpg";